import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import DemoUsersV1 from "./DemoUsersV1/DemoUsersV1";
import DemoUsersV2 from "./DemoUsersV2/DemoUsersV2";
import DemoUsersV3 from "./DemoUsersV3/DemoUsersV3";
import DemoUsersV4 from "./DemoUsersV4/DemoUsersV4";
import "./DemoUsers.css";

const DemoUsers = () => {
  const [version, setVersion] = useState("v1");

  return (
    <div className="mobile-app-container">
      <div className="mobile-device-container">
        <div className="mobile-screen">
          <div className="mobile-content">
            {version === "v1" && <DemoUsersV1 />}
            {version === "v2" && <DemoUsersV2 />}
            {version === "v3" && <DemoUsersV3 />}
            {version === "v4" && <DemoUsersV4 />}
          </div>
        </div>
      </div>

      <div className="mobile-version-controls">
        <button
          onClick={() => setVersion("v1")}
          className={`version-btn ${version === "v1" ? "active" : ""}`}
        >
          V1
        </button>
        <button
          onClick={() => setVersion("v2")}
          className={`version-btn ${version === "v2" ? "active" : ""}`}
        >
          V2
        </button>
        <button
          onClick={() => setVersion("v3")}
          className={`version-btn ${version === "v3" ? "active" : ""}`}
        >
          V3
        </button>
        <button
          onClick={() => setVersion("v4")}
          className={`version-btn ${version === "v4" ? "active" : ""}`}
        >
          V4
        </button>
      </div>
    </div>
  );
};

export default observer(DemoUsers);
